import Resources from './resources';
import { activateError, showInvalidCourseModal } from '../containers/error-handling/error-handling-actions';

class Intercept3pResourcesError {
  static addResourceResponseErrorInterceptor(dispatch) {
    const interceptor = Intercept3pResourcesError.handleErrors.bind(this, dispatch);
    Resources.env.addResponseInterceptor(interceptor);
  }

  static handleErrors(dispatch, result) {
    let valid = true;
    let invalidCourse = false;
    try {
      if (result.status > 399 && result.status < 600) {
        if (result.status === 404 && result.code === 'QuestionsNotFound') {
          invalidCourse = true;
        }
        valid = false;
      }
    } catch (e) {
      valid = false;
    }

    if (!valid && !invalidCourse) {
      dispatch(activateError(result.status));
    }

    if (invalidCourse) {
      dispatch(showInvalidCourseModal());
    }

    result.valid = valid;

    return result;
  }
}

export default Intercept3pResourcesError;
